export default __webpack_public_path__ + "static/bonvivant-96c7ee283be3f5b8ea7d572f3944d3da.woff2";